import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import ExportButton from "@/app/shared/export-button";
import { Button } from "rizzui";
import { Link } from "react-router-dom";
import { PiPlusBold } from "react-icons/pi";

interface HeaderProps {
    title: string;
    hideButton: boolean;
}

export default function notificationPageHeader({ title, hideButton }: HeaderProps) {
    const pageHeader = {
        title: title,
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                href: routes.settings.notifications,
                name: "notification",
            },
        ],
    };
    return (
        <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
           
        </PageHeader>
    );
}
